import { render } from "./SectionFotobox.vue?vue&type=template&id=05cf9086&scoped=true"
const script = {}

import "./SectionFotobox.vue?vue&type=style&index=0&id=05cf9086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cf9086"]])

export default __exports__